import orsersFeatureData from '@/components/customer/ordersFeatureData.vue';
function setCardList(status = 'default', res) {
  if (status == 'array') {
    return setarray(res);
  }
  if (status == 'datalist') {
    return setDatalistArr(res);
  }
  if (status == 'default') {
    return setdefaultArr();
  }
}

function setarray(res) {
  function getName(bind) {
    if (res.data[bind]) {
      return `服务人员：${res.data[bind].username || '-'}`;
    } else {
      return '服务人员：-';
    }
  }

  function listLength(bind) {
    let list = res.data[bind];
    if (list && list !== '-') {
      return list.length;
    } else {
      return 0;
    }
  }

  function setCustomerInfo(bind) {
    return {
      comType: 'popoverText',
      text: getName(bind),
      colType: 'serviceInfo',
      bind: bind,
      disabled: res.data[bind] == '-' || !res.data[bind].username,
      dataStyle(scope, tableData, bind) {
        let val = res.data[bind];
        if (!val) return false;
        return {
          name: val.username || '-',
          corp: val.companyName || '-',
          deptName: val.deptName || '-',
          mobile: val.phone || '-',
          email: val.email || '-',
        };
      },
    };
  }

  function emailType(type) {
    switch (type) {
      case 1:
        return '新版企业邮箱';
      case 2:
        return '旧版企业邮箱';
      case 3:
        return '不使用';
      case 4:
        return '新版邮箱列表';
      default:
        return '-';
    }
  }
  return [
    {
      title: '客户联系人信息',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        {
          label: '联系人',
          data: res.data.name,
        },
        {
          label: '手机号',
          data: res.data.mobile,
        },
        {
          label: '邮箱',
          comType: 'popoverText',
          text: `邮箱：${res.data.email}`,
          subText: res.data.email,
        },
        {
          label: '客户询盘接收邮箱',
          comType: 'popoverText',
          disabled: res.data.inquiryReceiveEmailList === '-',
          text: `客户询盘接收邮箱： ${listLength('inquiryReceiveEmailList')}条`,
          width: '300',
          colType: orsersFeatureData,
          value: res.data.inquiryReceiveEmailList,
        },
      ],
    },
    {
      title: '销售联系人信息',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        {
          label: '联系人',
          data: res.data.seller,
          style: res.data.agentName == '-' ? "" : { display: "none" } , // 根据是否是渠道判断是否展示
        },
        {
          label: '手机号',
          data: res.data.sellerMobile,
          style: res.data.agentName == '-' ? "" : { display: "none" } , // 根据是否是渠道判断是否展示
        },
        {
          label: '邮箱',
          data: res.data.sellerEmail,
          style: res.data.agentName == '-' ? "" : { display: "none" },
        },

        // 渠道商显示的字段
        {
          label: '渠道商销售',
          data: res.data.agentEmployeeName,
          style: res.data.agentName != '-' ? "" : { display: "none" } , // 根据是否是渠道判断是否展示
        },
        {
          label: '手机号',
          data: res.data.agentMobile,
          style: res.data.agentName != '-' ? "" : { display: "none" } , // 根据是否是渠道判断是否展示
        },      
        {
          label: '归属渠道商',
          comType: 'popoverText',
          text: `归属渠道商： ${res.data.agentName}`,
          subText: res.data.agentName,
          style: res.data.agentName != '-' ? "" : { display: "none" } , // 根据是否是渠道判断是否展示
        },
        {
          label: '渠道商经理',
          data: res.data.seller,
          style: res.data.agentName != '-' ? "" : { display: "none" },
        }
      ],
    },
    {
      title: '网站',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        setCustomerInfo('siteServiceStaff'),
        {
          label: '域名',
          data: res.data.domain,
          dataStyle: {
            color: '#409eff',
          },
          click(value) {
            window.open('//' + value.data, '_blank');
          },
        },
        {
          label: '域名到期',
          data: res.data.formatDomainExpirationTime,
        },
        {
          label: '证书到期',
          data: res.data.sslDueTime,
        },
        {
          label: '语种',
          data: res.data.languagesName,
        },
        {
          label: 'GAID',
          data: res.data.accessData,
        },
        {
          label: '询盘邮箱',
          comType: 'popoverText',
          text: `询盘邮箱：${res.data.inquiryEmail}（${emailType(
            res.data.qyEmailType
          )}）`,
          subText: `${res.data.inquiryEmail}（${emailType(
            res.data.qyEmailType
          )}）`,
        },
      ],
    },
    {
      title: '社媒',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        setCustomerInfo('socialServiceStaff'),
        {
          label: '平台',
          data: res.data.platformName,
          dataStyle: {
            color: '#409eff',
          },
        },
        {
          label: '单月应发',
          data: res.data.taskCount,
          dataStyle: {
            color: '#409eff',
          },
        },
      ],
    },
    {
      title: 'Google推广',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        setCustomerInfo('googleServiceStaff'),
        {
          label: 'CID',
          data: res.data.googleCidAccountVal,
        },
      ],
    },
    {
      title: 'FB推广',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        setCustomerInfo('facebookServiceStaff'),
        {
          label: '主页名称',
          comType: 'popoverText',
          text: `主页名称：${res.data.pageName}`,
          subText: `${res.data.pageName}`,
        },
        {
          label: 'FBID',
          data: res.data.facebookCidAccountVal,
        },
        {
          label: '主页ID',
          data: res.data.pageId,
        },
      ],
    },
    {
      title: '视频拍摄',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        setCustomerInfo('videoServiceStaff'),
        {
          label: '拍摄时长',
          data: res.data.mins,
        },
        {
          label: '拍摄个数',
          data: res.data.number,
        },
      ],
    },
  ];
}

function setDatalistArr() {
  function setInquiryEmail(bind) {
    return {
      comType: 'popoverText',
      bind,
      getData(row, bind) {
        if (row[bind]) {
          return `询盘邮箱：${row[bind]}`;
        }
        return '询盘邮箱：-';
      },
    };
  }
  function setCustomerInfo(bind) {
    return {
      comType: 'popoverText',
      colType: 'serviceInfo',
      bind,
      getData(row, bind) {
        if (row[bind] && row[bind].username) {
          return `服务人员：${row[bind].username}`;
        }
        return '服务人员：-';
      },
      dataStyle(scope, tableData, bind) {
        let res = scope.row[bind];
        if (!res) return false;
        return {
          name: res.username || '-',
          corp: res.companyName || '-',
          deptName: res.deptName || '-',
          mobile: res.phone || '-',
          email: res.email || '-',
        };
      },
    };
  }
  return [
    {
      title: '网站',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        setCustomerInfo('siteServiceStaff'),
        {
          label: '域名',
          bind: 'domain',
          dataStyle: {
            color: '#409eff',
          },
          click(value, item, row) {
            window.open('//' + row[value.bind], '_blank');
          },
        },
        {
          label: '域名到期',
          bind: 'formatDomainExpirationTime',
        },
        {
          label: '证书到期',
          bind: 'sslDueTime',
        },
        {
          label: '语种',
          bind: 'languagesName',
        },
        {
          label: 'GAID',
          bind: 'gaId',
        },
        setInquiryEmail('inquiryEmail'),
        // {
        //   // label: '询盘邮箱',
        //   // bind: 'inquiryEmail'
        //   label: '询盘邮箱',
        //   comType: 'popoverText',
        //   text: `询盘邮箱：${res.data.inquiryEmail}`,
        //   subText: `${res.data.inquiryEmail}`,
        //   bind: 'inquiryEmail'
        // }
      ],
    },
    {
      title: '社媒',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        setCustomerInfo('socialServiceStaff'),
        {
          label: '平台',
          bind: 'platformName',
          dataStyle: {
            color: '#409eff',
          },
        },
        {
          label: '单月应发',
          bind: 'taskCount',
          dataStyle: {
            color: '#409eff',
          },
        },
      ],
    },
    {
      title: 'Google推广',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        setCustomerInfo('googleServiceStaff'),
        {
          label: 'CID',
          bind: 'cid',
        },
      ],
    },
    {
      title: '视频拍摄',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        setCustomerInfo('videoServiceStaff'),
        {
          label: '拍摄时长',
          bind: 'mins',
          formatter(data) {
            if (data && data != '-') {
              return `${data}min`;
            }
            return data;
          },
        },
        {
          label: '拍摄个数',
          bind: 'number',
        },
      ],
    },
  ];
}

function setdefaultArr() {
  return [
    {
      title: '客户联系人信息',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        {
          label: '联系人',
          data: '-',
        },
        {
          label: '手机号',
          data: '-',
        },
        {
          label: '邮箱',
          data: '-',
        },
        {
          label: '客户询盘接收邮箱',
          data: '-',
        },
      ],
    },
    {
      title: '销售联系人信息',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        {
          label: '联系人',
          data: '-',
        },
        {
          label: '手机号',
          data: '-',
        },
        {
          label: '邮箱',
          data: '-',
        },
      ],
    },
    {
      title: '网站',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        {
          label: '服务人员',
          data: '-',
        },
        {
          label: '域名',
          data: '-',
        },
        {
          label: '证书到期',
          data: '-',
        },
        {
          label: '语种',
          data: '-',
        },
        {
          label: 'GAID',
          data: '-',
        },
        {
          label: '询盘邮箱',
          data: '-',
        },
      ],
    },
    {
      title: '社媒',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        {
          label: '服务人员',
          data: '-',
        },
        {
          label: '平台',
          data: '-',
        },
        {
          label: '单月应发',
          data: '-',
        },
      ],
    },
    {
      title: 'Google推广',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        {
          label: '服务人员',
          data: '-',
        },
        {
          label: 'CID',
          data: '-',
        },
      ],
    },
    {
      title: 'FB推广',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        {
          label: '主页名称',
          data: '-',
        },
        {
          label: 'FBID',
          data: '-',
        },
        {
          label: '主页ID',
          data: '-',
        },
      ],
    },
    // {
    //   title: 'FB推广',
    //   bodyStyle: {
    //     height: '240px',
    //   },
    //   dataList: [
    //     {
    //       label: '服务人员',
    //       data: '-',
    //     },
    //     {
    //       label: '主页名称',
    //       data: '-',
    //     },
    //     {
    //       label: '主页ID',
    //       data: '-',
    //     },
    //     {
    //       label: '账户ID',
    //       data: '-',
    //     },
    //   ],
    // },
    {
      title: '视频拍摄',
      bodyStyle: {
        height: '240px',
      },
      dataList: [
        {
          label: '服务人员',
          data: '-',
        },
        {
          label: '拍摄时长',
          data: '-',
        },
        {
          label: '拍摄个数',
          data: '-',
        },
      ],
    },
  ];
}
export default setCardList;
